import { render, staticRenderFns } from "./CardProfitLossNew.vue?vue&type=template&id=678fb449&scoped=true&"
import script from "./CardProfitLossNew.vue?vue&type=script&lang=ts&"
export * from "./CardProfitLossNew.vue?vue&type=script&lang=ts&"
import style0 from "./CardProfitLossNew.vue?vue&type=style&index=0&id=678fb449&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678fb449",
  null
  
)

export default component.exports